import { RoutePaths } from '@interfaces/routePaths'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export const DefaultPath = (): JSX.Element => {
  const location = useLocation()
  const navigate = useNavigate()
  const { pathname } = location

  useEffect(() => {
    pathname === '/' &&
      navigate(`${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`)
  }, [pathname])

  return <Outlet />
}
